import type { SiteItem } from '@/mocks/sites';

interface SiteCardProps {
  site: SiteItem;
}

export default function SiteCard({ site }: SiteCardProps) {
  const firstChar = site.name.charAt(0);

  return (
    <a
      href={site.url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="group block p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
          <span className="text-sm font-semibold text-primary-600">{firstChar}</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
              {site.name}
            </h3>
            {site.isHot && (
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary-500/10 text-primary-600 font-medium whitespace-nowrap flex-shrink-0">热门</span>
            )}
            {site.isNew && (
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-accent-500/10 text-accent-600 font-medium whitespace-nowrap flex-shrink-0">新上</span>
            )}
          </div>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{site.description}</p>
        </div>
        <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <i className="ri-arrow-right-up-line text-sm text-primary-500"></i>
        </div>
      </div>
    </a>
  );
}